<template>
    <div class="footer-content">
        <div class="content">
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
                Good Leasing Company Limited Pico Finance
            </div>
            <div class="pico">
                <div>0105560043965</div>
                <div>Pico Finance：1046/2565</div>
            </div>
            <div class="btns">
                <div class="btn" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)">
                    {{ btn.name }}
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="address">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                200 ถนนสวนผัก แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพมหานคร 10170
            </div>
            <div class="address">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                +66 0614531326
            </div>
            <div class="address">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                apps@good-leasing.com
            </div>
        </div>
        <div class="c">
            © 2026 Hak Cipta milik Good Leasing Company Limited Pico Finance
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const btns = [
    {
        name: "หน้าแรก",
        path: "/",
    },
    {
        name: "เกี่ยวกับเรา",
        path: "/service",
    },
    {
        name: "บริการ",
        path: "/about",
    },
    {
        name: "ติดต่อเรา",
        path: "/contact",
    },
];
const handleClick = (path) => {
    console.log("path", path);
    router.replace(path);
};
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 270px;
    background: #00233D;
    padding: 0 200px;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding-top: 43px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 65px;

        .title {
            max-width: 293px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            color: #D3D3D3;
            line-height: 15px;

            img {
                width: 44px;
                height: 44px;
                object-fit: contain;
                margin-right: 7px;
            }
        }

        .pico {
            font-weight: 500;
            font-size: 12px;
            color: #D3D3D3;
            line-height: 18px;
        }

        .btns {
            max-width: 425px;
            display: flex;
            justify-content: space-around;
            flex: 1;

            .btn {
                font-weight: bold;
                font-size: 14px;
                color: #D3D3D3;
                line-height: 14px;
                cursor: pointer;
            }
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 44px;

        .address {
            max-width: 302px;
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            color: #D3D3D3;
            line-height: 18px;

            .icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 11px;
            }
        }
    }

    .c {
        font-weight: 500;
        font-size: 12px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>